<script setup>
import CategoryNav from '@/components/blog/CategoryNav.vue'
import PostCard from '@/components/blog/PostCard.vue'
import PostPagination from '@/components/blog/PostPagination.vue'
import SectionHeading from '@/components/ui/SectionHeading.vue'

defineProps({
    posts: { type: Object, required: true },
    categories: { type: Array, default: () => [] },
})
</script>

<template>
    <Head>
        <title>Blog</title>
        <meta
            head-key="description"
            name="description"
            content="Články, novinky z legislativy a praktické tipy ze světa účetnictví a daní od týmu SolveCount."
        />
        <link
            head-key="feed"
            rel="alternate"
            type="application/rss+xml"
            title="Blog SolveCount"
            href="/blog/feed.xml"
        />
    </Head>

    <section class="bg-white pt-32 pb-20 md:pt-40 md:pb-28">
        <div class="mx-auto max-w-7xl px-6 lg:px-10">
            <div class="max-w-2xl">
                <SectionHeading
                    eyebrow="Blog"
                    title="Účetnictví a daně srozumitelně"
                    lede="Praktické tipy, novinky z legislativy a návody, které vám usnadní podnikání."
                />
            </div>

            <div class="mt-10">
                <CategoryNav :categories="categories" />
            </div>

            <div
                class="mt-12 grid gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3"
                v-if="posts.data.length"
            >
                <PostCard
                    v-for="post in posts.data"
                    :key="post.slug"
                    :post="post"
                />
            </div>

            <p
                class="mt-16 text-lg text-zinc-600"
                v-else
            >
                Zatím tu nejsou žádné články. Brzy přidáme první.
            </p>

            <PostPagination
                :links="posts.links"
                :last-page="posts.last_page"
            />
        </div>
    </section>
</template>
